<template>
    <div
        :id="id"
        class="lni-u-mt3"
    >
        <h2 class="lni-u-heading--2">
            {{ getData('documents.heading') }}
        </h2>
        <p class="lni-u-mt2">
            {{ getData('documents.lead') }}
        </p>
        <div class="lni-u-mt2 lni-u-mb1">
            <lni-select
                :id="`${id}_upload_document-type`"
            />
        </div>
        <lni-file-upload-form
            :id="`${id}_upload`"
            title=""
            :hasVideos="true"
            :sizeLimit="20971520"
            :fileLimit="10"
            :multiple="false"
            :charLimit="200"
            :uploadAction="`${id}/upload`"
            :hasInlineMessages="true"
        >
            <template
                slot="uploads"
            >
                <div :id="`${id}_toggler`">
                    <lni-file-uploads
                        :id="`${id}_file-uploads`"
                        :allowDelete="true"
                        @deleted="handleDeleted"
                    />
                </div>
            </template>
        </lni-file-upload-form>
    </div>
</template>

<script>
export default {
    name: 'LniRetaliationDocuments',
    methods: {
        getData(name) {
            return this.$store.getters['appState/data'] ? this.$store.getters['appState/data'](name) : '';
        },
        handleDeleted(files) {
            this.$store.commit('setAttribute', {
                id: `${this.id}_upload`,
                attribute: 'uploadedFiles',
                value: files,
            }, {
                root: true,
            });
        },
    },
};
</script>